module.exports = __webpack_public_path__ + "static/media/Step 10b-Bookkeeper.9509fd96.png";